import { StokResimEkleGuncellePage } from './../stok-resim-ekle-guncelle/stok-resim-ekle-guncelle';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { BllResimler } from './../../../providers/bll/bll-resimler';
import { BllViewStoklar } from './../../../providers/bll/bll-ViewStoklar';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { NL_StokKarti } from '../../../models/NL_StokKarti';

@Component({
  selector: 'page-stok-detay',
  templateUrl: 'stok-detay.html',
})
export class StokDetayPage {
  stok: NL_StokKarti = new NL_StokKarti();
  stokListesiView = [];
  stokResimListesi = [];
  constructor(public navCtrl: NavController,
    public bllviewStokkarti: BllViewStoklar,
    public bllResim: BllResimler,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
    public modalCtrl:ModalController,
    public navParams: NavParams) {
    this.stok = navParams.data.stok;
    bllviewStokkarti.getAllWithSpecificQuery("ID=" + this.stok.ID).then(a => {
      this.stokListesiView = a;
    })
  }

  ionViewDidLoad() {
   this.resimListele();
  }

  resimListele() {
    this.bllResim.getAll({ Image_Type: 1, Source_Ref: this.stok.ID }).then(a => {
      var sonuc = <any>a;
      this.stokResimListesi = sonuc;
     
    })
  }
  kapat()
  {
    this.viewCtrl.dismiss();
  }
  resimEkleGuncellePage(resim) {
    let modal = this.modalCtrl.create(StokResimEkleGuncellePage, { stok: this.stok });
    modal.present();
  }
  resimSil(stokResim) {
    var formData = new FormData();
    formData.append("resim_adi", stokResim.IMAGE_NAME);
    this.bllOrtak.islem(formData, "ResimSil", "", true).then(a => {
      this.bllResim.delete({ PK_ID: stokResim.PK_ID }).then(b => {
        this.resimListele();
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stok-detay/stok-detay.ts